import Api from '../common/Api';
import {Backend, headers} from "../common/Config";
import Helpers from '../common/Helpers';

export default class Fuec {

    static async save(form) {
        const response = await Api.post({
            url: `${Backend}/fuec/create`,
            form,
            headers
        });
        return Helpers.dataReturn(response);
    };

    static async update(form) {
        const response = await Api.post({
            url: `${Backend}/fuec/update`,
            form,
            headers
        });
        return Helpers.dataReturn(response);
    };

    static async get(page = 0, form) {
        const response = await Api.post({
            url: `${Backend}/fuec/list/${page}`,
            form,
            headers
        });
        return Helpers.dataReturn(response);
    };

    static async getById(id) {
        const response = await Api.get({
            url: `${Backend}/fuec/get/${id}`,
            headers
        });
        return Helpers.dataReturn(response);
    };

    static async doc(id) {
        const response = await Api.get({
            url: `${Backend}/fuec/doc/${id}`,
            headers
        });
        return Helpers.dataReturn(response);
    };

}
